module.exports = __webpack_public_path__ + "img/19.0fd35b50.jpg";